import styled from 'styled-components/macro';
import { UI } from 'utils/constants';
import { colors } from 'css/constants';

export const SidebarPrimitive = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: space-between;
  width: ${UI.PROJECT_BAR_WIDTH};
  background-color: ${colors.darkestGrey};
  padding: 0 10px;
  color: #fff;
  overflow-y: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  padding-bottom: 14px;
`;

export const ProjectTile = styled.div`
  opacity: ${({ selected }) => (selected ? 1 : 0.5)};
  border: ${({ selected }) => selected && '1px solid #cccccb'};
  border-radius: 5px;
  cursor: pointer;
  margin-top: 14px;
  padding: 1px;
  height: 60px;
  width: 100%;

  &:hover {
    border: 1px solid #cccccb;
  }
`;

export const TileContent = styled.div`
  align-items: center;
  border: 1px solid rgb(204 204 203 / 50%);
  border-radius: 3px;
  color: ${({ color }) => `${color}`};
  display: flex;
  font-size: 20px;
  justify-content: center;
  text-align: center;
  padding: 3px;
  height: 100%;
`;

export const ProjectLink = styled.a`
  text-decoration: none;
`;
